import { ChainId } from '@lydiafinance/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.FUJI]: '0xb465Fd2d9C71d5D6e6c069aaC9b4E21c69aAA78f',
  [ChainId.AVALANCHE]: '0x98e2060F672FD1656a07bc12D7253b5e41bF3876',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
